<div class="container">
  <div fxLayout fxLayoutGap="36px" fxLayoutAlign="flex-start baseline">
    <div class='table-title'>{{ card.title }}</div>

    <app-filter-bar
      *ngIf='initDates'
      [filters]="['dateRange']"
      [initialValue]='initDates'
      [smallNewDateRange]="true"
      [preventFiltersStore]="true"
      (filterChanges)="onFilterChanges($event)"
    ></app-filter-bar>
  </div>

  <div class="progress-bar-wrapper">
    <mat-progress-bar *ngIf='isLoading' [mode]="'indeterminate'"></mat-progress-bar>
  </div>

  <ng-container *ngIf="!isLoading">
    <ng-container *ngFor="let group of metricGroups">
      <app-hours-table
        *ngIf="group.node.metricGroup.metricvalueSet.edges.length"
        [group]="group.node.metricGroup"
        [groupId]="group.id"
        [filterCache]="filterCache"
      ></app-hours-table>
    </ng-container>
  </ng-container>
</div>
